import $ from 'jquery';
import 'slick-carousel';

const ourMill = () => {
  const slider = $('.c-slider--mill');
  if (slider.length) {
    const options = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      centerMode: true,
      centerPadding: '20px',
      variableWidth: false,
      adaptiveHeight: true,
      prevArrow:
        '<button type="button" class="button c-slider--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.73 67.39"><defs><style>.cls-1{fill:#45443D;}</style></defs><title>Left-Arrow</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M118.84,26.66A34.33,34.33,0,0,0,142.61,29c-5.5-20.41-18.26-32-43.44-28.4C99.17.64,106.56,20.58,118.84,26.66Z"/><path class="cls-1" d="M84.64,26.66A34.34,34.34,0,0,0,108.41,29C102.91,8.63,90.15-2.93,65,.64,65,.64,72.36,20.58,84.64,26.66Z"/><path class="cls-1" d="M50.71,26.66A34.34,34.34,0,0,0,74.48,29C69,8.63,56.21-2.93,31,.64,31,.64,38.43,20.58,50.71,26.66Z"/><path class="cls-1" d="M84.64,40.73C72.36,46.8,65,66.74,65,66.74c25.18,3.58,37.94-8,43.44-28.39A34.34,34.34,0,0,0,84.64,40.73Z"/><path class="cls-1" d="M50.71,40.73C38.43,46.8,31,66.74,31,66.74c25.18,3.58,37.94-8,43.45-28.39A34.34,34.34,0,0,0,50.71,40.73Z"/><path class="cls-1" d="M47.54,33.79c-16.19-15.2-32-15.68-47.54.66C16.28,50.41,32.08,48.59,47.54,33.79Z"/><path class="cls-1" d="M132.7,37.26a34,34,0,0,0-13.86,3.47c-12.28,6.07-19.67,26-19.67,26,24,3.41,36.7-6.93,42.61-25.56h56.95V37.24h-66Z"/></g></g></svg></button>',
      nextArrow:
        '<button type="button" class="button c-slider--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.73 67.39"><defs><style>.cls-1{fill:#45443D;}</style></defs><title>Right-Arrow</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M79.89,40.73a34.34,34.34,0,0,0-23.77-2.38c5.5,20.41,18.27,32,43.45,28.39C99.57,66.74,92.17,46.8,79.89,40.73Z"/><path class="cls-1" d="M114.09,40.73a34.34,34.34,0,0,0-23.77-2.38c5.5,20.41,18.27,32,43.45,28.39C133.77,66.74,126.37,46.8,114.09,40.73Z"/><path class="cls-1" d="M148,40.73a34.34,34.34,0,0,0-23.77-2.38c5.5,20.41,18.26,32,43.44,28.39C167.7,66.74,160.31,46.8,148,40.73Z"/><path class="cls-1" d="M114.09,26.66c12.28-6.08,19.68-26,19.68-26-25.18-3.57-38,8-43.45,28.4A34.34,34.34,0,0,0,114.09,26.66Z"/><path class="cls-1" d="M148,26.66c12.28-6.08,19.67-26,19.67-26-25.18-3.57-37.94,8-43.44,28.4A34.34,34.34,0,0,0,148,26.66Z"/><path class="cls-1" d="M151.2,33.6c16.19,15.2,32.05,15.68,47.53-.66C182.46,17,166.65,18.79,151.2,33.6Z"/><path class="cls-1" d="M66,30.13a34.1,34.1,0,0,0,13.85-3.47c12.28-6.08,19.68-26,19.68-26C75.58-2.76,62.87,7.57,57,26.2H0v3.95H66Z"/></g></g></svg></button>',
      autoplay: false,
      infinite: false,
      initialSlide: 0,
      asNavFor: '.c-slider--mill__nav',
    };
    if ($(window).width() > 1024) {
      options.variableWidth = true;
      options.adaptiveHeight = false;
    }
    let currentSlider;
    let currSlide;
    slider.on('init', slick => {
      currentSlider = $(slick.target);
      currSlide = currentSlider.find('.slick-current');
      currentSlider
        .find('.c-slider--prev')
        .css('margin-left', currSlide.width() / -2);
      currentSlider
        .find('.c-slider--next')
        .css('margin-left', currSlide.width() / 2);
    });
    slider.on('afterChange', () => {
      currSlide = currentSlider.find('.slick-current');
      currentSlider
        .find('.c-slider--prev')
        .css('margin-left', currSlide.width() / -2);
      currentSlider
        .find('.c-slider--next')
        .css('margin-left', currSlide.width() / 2);
    });
    slider.slick(options);
  }

  const sliderNav = $('.c-slider--mill__nav');
  if (sliderNav.length) {
    let sts = 2;
    if ($(window).width() > 1024) {
      sts = sliderNav.find('.c-slider--mill__nav-item').length;
    }
    const option = {
      slidesToShow: sts,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      asNavFor: '.c-slider--mill',
    };
    sliderNav.slick(option);
    const buttons = sliderNav.find('[data-slide]');
    if (buttons.length) {
      buttons.click(ev => {
        ev.preventDefault();
        let $self = $(ev.target);
        if (!$self.hasClass('c-slider--mill__btn')) {
          $self = $self.closest('.c-slider--mill__btn');
        }
        const nextSlide = $self.data('slide');
        slider.slick('slickGoTo', nextSlide, false);
      });
    }
  }
};
export default ourMill;



// WEBPACK FOOTER //
// ./src/scripts/modules/our-mill.js